import { useEffect } from "react";

/** 모달이 떠 있는 동안 뒤 문서의 스크롤을 막는다. 문서 스크롤은 html 이 진다
 *  (`.shell` 은 min-height 100dvh 라 자기 스크롤이 없다). 모달이 겹쳐 떠도 마지막
 *  하나가 닫힐 때 원래 값으로 돌린다 — 먼저 닫힌 쪽이 잠금을 풀면 남은 모달 뒤가 다시 구른다.
 *  overflow 만 바꾸므로 스크롤 위치는 그대로 남는다. */
let holders = 0;
let saved = "";

export function useScrollLock(on = true) {
  useEffect(() => {
    if (!on) return;
    const root = document.documentElement;
    if (holders === 0) {
      saved = root.style.overflow;
      root.style.overflow = "hidden";
    }
    holders += 1;
    return () => {
      holders -= 1;
      if (holders === 0) root.style.overflow = saved;
    };
  }, [on]);
}
